import React from 'react';
import _ from 'lodash';
import moment from 'moment';

moment.locale('de');
function Ribbon({ product, isOfferActive, fontsize }) {

    if(!_.isNil(product.stock) && product.stock < 1 ){
        product.soldOut = true
    }
    
    let currentDate = moment(new Date());
    let createdDate = moment(new Date(product?.createdAt)).startOf("day");
    let result = currentDate.diff(createdDate, 'days')
    
    let isNewProduct = result < 14;

    let hasNoOffer = (product.originalPrice && product.preisAb && product.originalPrice === product.preisAb)  || 
                     !isOfferActive || 
                     ((product.aktionsPreis && product.aktionsPreis >= product.vk_preis) && (product.aktionsPreisPickup && product.aktionsPreisPickup >= product.pickup_preis))

    return (
        <>
        {product.soldOut &&  <div id="soldout-ribbon" style={{fontSize: fontsize}} className="uk-text-default uk-position-z-index uk-position-top-left aps-soldout-ribbon soldout-theme" aria-label="Bald wieder Lieferbar">Bald wieder lieferbar</div> }
        {!product.soldOut && product.showRemainingStock &&  <div id="stock-ribbon" style={{fontSize: fontsize}} className="uk-text-bold uk-position-z-index uk-position-top-left aps-stock-ribbon stock-theme" aria-label={`Nur noch ${product.stock} auf Lager`}>Nur noch {product.stock} auf Lager</div> }
        <div className='uk-position-z-index uk-position-top-right'>
            { isNewProduct && <div id="new-ribbon" style={{fontSize: fontsize}} className="uk-text-default aps-new-ribbon new-theme" aria-label='neuer Artikel'> NEU </div> }    
            { !hasNoOffer && <div id="angebote-ribbon" style={{fontSize: fontsize}} className="uk-text-default aps-angebote-ribbon angebote-theme" aria-label='rabattierter Artikel'> % </div> }    
        </div>
        </>
    );
}

export default Ribbon;
